<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
<div class="viewport-content" [ngClass]="{ hidden: hide(), notSlider: notSlider !== '' }">
  <div #homeSlideShow class="keen-slider">
    @for (slide of slides(); track $index) {
      <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
      <div
        class="keen-slider__slide number-slide"
        [ngStyle]="{
          '--slideshow-caption-background-color-desktop': slide?.text?.textbkgcolor?.desktop || 'transparent',
          '--slideshow-caption-background-color-tablet-mobile': slide?.text?.textbkgcolor?.tabletmobile || 'transparent',
        }"
      >
        <app-home-top-slideshow-item [slide]="slide" />
      </div>
    }

    <button type="button" class="arrow arrow--left" [ngClass]="arrowVisibility" (click)="slider.prev()">
      <img alt="Left arrow" [src]="'assets/images/arrow-left-white.svg'" />
      <span class="sr-only">Previous</span>
    </button>

    <button type="button" class="arrow arrow--right" [ngClass]="arrowVisibility" (click)="slider.next()">
      <img alt="Right arrow" [src]="'assets/images/arrow-right-white.svg'" />
      <span class="sr-only">Next</span>
    </button>

    <div class="dots" [ngClass]="dotsVisibility">
      <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
      @for (slide of dotHelper; track slide; let i = $index) {
        <button type="button" [class]="'dot ' + (i === currentSlide ? 'active' : '')" (click)="slider.moveToIdx(i)">
          <span class="sr-only">Slider step {{ i }}</span>
        </button>
      }
    </div>
  </div>
</div>
